export default {
  meta: {
    title: '设置拍摄分析时段',
  },
};
